import Vue from 'vue'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI, { locale })



// WEBPACK FOOTER //
// ./src/plugins/ui/element-ui.js